import { Divider, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Model, UseForm } from "../../../hooks";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";
import { Button } from "../../../controls";
import { Alert, Form, Tabs } from "../../../layout";
import { toast } from "react-toastify";
import OrgInfo from "./OrgInfo";
import ContactInfo from "./ContactInfo";
import AddressBook from "./AddressBook";

const SettingsForm = () => {
  const { OrgMdl } = Model();
  const { authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleInpCheck,
    handleFile,
    resetFormControls,
  } = UseForm(OrgMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    authUser &&
      API(controller.Org + action.GetAuthUserOrg).get(
        (res) =>
          res.status === 200 &&
          setValues((x) => ({
            ...x,
            ...RmvEmptyProp({ ...res.result }),
          }))
      );
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const validateForm = () => {
    let temp = {};
    temp.orgName =
      values.orgName !== "" ? "" : "Organization name is required.";
    temp.currencyId = values.currencyId !== "" ? "" : "Currency is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const onComplete = (res) => {
        if (res && res.status === 200) {
          res.result && setValues({ ...res.result });
          toast.success(res?.msg);
        } else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
        setLoading(false);
      };
      API(controller.Org + action.Put).put(
        ToFormData(
          RmvEmptyProp({ ...values, updateDate: new Date().toISOString() })
        ),
        onComplete
      );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="flex justify-between items-center p-[8px]">
            <div>
              <span className="text-[20px] mb-[5px] font-medium text-gray-500 uppercase border-left ml-[5px]">
                Org. Information
              </span>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                Save Changes
              </Button>
            </div>
          </div>
          <Divider />

          <div className="p-[15px]">
            <Tabs
              className="mt-[10px]"
              header={[
                { label: "Org. Info", icon: "" },
                { label: "Contact Info.", icon: "" },
                { label: "Address Book", icon: "" },
              ]}
            >
              {/* Organization Information */}
              <OrgInfo
                {...{ values, setValues, errors, handleFile, handleInpChg }}
              />

              {/* Contact Information */}
              <ContactInfo {...{ values, errors, handleInpChg }} />

              {/* Addresses */}
              <AddressBook
                {...{ values, errors, handleInpChg, handleInpCheck }}
              />
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default SettingsForm;
